export default "__VITE_ASSET__AcbcuEv4__"